import { useState } from "react";
import { Flame, Sparkles, Dumbbell } from "lucide-react";
import { FadeUp } from "./FadeUp";

const GOALS = [
  {
    id: "fat-loss",
    label: "Fat Loss",
    icon: Flame,
    calorie: "Moderate calorie deficit (~500 kcal/day)",
    training: "Full-body strength training + daily step focus",
    workouts: "4-5 workouts / week",
  },
  {
    id: "lean-toned",
    label: "Lean & Toned",
    icon: Sparkles,
    calorie: "Slight deficit with high protein intake",
    training: "Strength training mixed with light cardio",
    workouts: "4 workouts / week",
  },
  {
    id: "muscle-gain",
    label: "Muscle Gain",
    icon: Dumbbell,
    calorie: "Calorie surplus with high protein intake",
    training: "Progressive overload split training",
    workouts: "5-6 workouts / week",
  },
];

export const GoalSelector = () => {
  const [goalId, setGoalId] = useState("fat-loss");
  const goal = GOALS.find((g) => g.id === goalId);

  return (
    <section id="plans" className="py-14 md:py-20 px-6 bg-[#0A0A0B]">
      <div className="max-w-4xl mx-auto">
        <FadeUp>
          <h2 className="font-display text-4xl sm:text-5xl text-white text-center mb-10">
            PICK YOUR GOAL
          </h2>
        </FadeUp>

        <div className="flex flex-wrap justify-center gap-3 mb-10">
          {GOALS.map((g) => (
            <button
              key={g.id}
              data-testid={`goal-pill-${g.id}`}
              onClick={() => setGoalId(g.id)}
              className={`tap-target px-6 py-3 rounded-full text-sm font-semibold transition-all duration-300 ${
                goalId === g.id
                  ? "bg-[#C6FF3D] text-black"
                  : "bg-[#141416] text-[#A1A1AA] border border-[#232326] hover:text-white"
              }`}
            >
              {g.label}
            </button>
          ))}
        </div>

        <div
          data-testid="goal-detail-card"
          className="bg-[#141416] border border-[#232326] rounded-[24px] p-8 sm:p-10"
        >
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 rounded-full bg-[#C6FF3D]/10 flex items-center justify-center">
              <goal.icon className="text-[#C6FF3D]" size={22} />
            </div>
            <h3 className="font-display text-2xl text-white">{goal.label}</h3>
          </div>
          <div className="grid sm:grid-cols-3 gap-8">
            <div>
              <span className="text-[#C6FF3D] text-xs font-semibold tracking-widest uppercase">Calorie Approach</span>
              <p className="text-white mt-2 text-sm">{goal.calorie}</p>
            </div>
            <div>
              <span className="text-[#C6FF3D] text-xs font-semibold tracking-widest uppercase">Training Style</span>
              <p className="text-white mt-2 text-sm">{goal.training}</p>
            </div>
            <div>
              <span className="text-[#C6FF3D] text-xs font-semibold tracking-widest uppercase">Frequency</span>
              <p className="text-white mt-2 text-sm">{goal.workouts}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
